import { useGrouppedAppointments } from "@/features/appointments/useGrouppedAppointments";
import {
  type HistoryGroup,
  getHistoryId,
  isHistoryGroup,
} from "@/features/history/utils";
import { useModals } from "@/features/modals/hooks";
import { getTaskUpdateDetail } from "@/features/tasks/utils";
import { type History, type Opportunity } from "@repo/api";
import { Text } from "@repo/skapa";
import { useTranslation } from "@repo/translation";
import { translateLabel, useSettings } from "@repo/ui";
import { trackAnalytics } from "@repo/utils";

import { HistoryListViewItem } from "./HistoryListViewItem";

interface Props {
  history: History | HistoryGroup;
  opportunity: Opportunity;
  dropInTaskId?: string;
}

export const AppointmentHistoryItem = ({
  history,
  opportunity,
  dropInTaskId,
}: Props) => {
  const { pushModal } = useModals();
  const { dateFnsLocale } = useTranslation();
  const { language, task_configuration } = useSettings();
  const entryId = getHistoryId(history);

  const { all: allAppointments } = useGrouppedAppointments(opportunity.id);
  const appointment = allAppointments.find(
    (item) =>
      item.orderNumber === entryId || item.appointmentId === Number(entryId)
  );
  const historyEntries = isHistoryGroup(history)
    ? history.prevEntries
    : undefined;

  return (
    <HistoryListViewItem
      history={history}
      control={appointment ? "navigational" : "default"}
      onClick={() => {
        if (appointment) {
          pushModal({
            type: "APPOINTMENT",
            appointment,
            historyEntries,
            projectId: opportunity.id,
          });
        }
        trackAnalytics("history.title");
      }}
      title={
        dropInTaskId
          ? `${translateLabel(history.details?.task_title)}: ${dropInTaskId}`
          : history.title
      }
      description={
        <>
          {dropInTaskId &&
            getTaskUpdateDetail(
              language,
              history,
              dateFnsLocale,
              task_configuration?.task_types
            )?.description?.map((el, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <Text key={i} textStyle="Body.S">
                {el}
              </Text>
            ))}
          <Text textStyle="Body.S">{history.note}</Text>
        </>
      }
    />
  );
};
